import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AppRoutes from './routes/AppRoutes';
import "./index.css";
import "./App.css";

function App() {
  return (
    <Router>
      <AppRoutes />
      <ToastContainer  autoClose={2000} closeOnClick pauseOnHover draggable />
    </Router>
  );
}

export default App;